import module from 'module';

module.factory('customReportSaved', (CacheFactory) =>
  CacheFactory.createCache('customReportSaved', {
    storageMode: 'localStorage',
    storagePrefix: 'nx__nonvolatile__',
  })
);